export default __webpack_public_path__ + "assets/china.ded8d79d.svg";